import React, { useEffect, useState } from "react";
import Input from "models/input/input";
import { useSearchParams } from "react-router-dom";
import { FacetFields } from "models/facet-fields";
import SolrService from "services/SolrService";
import NTHeader from "./nt-header";
import BaseHeader from "./base-header";

const { solrService } = new SolrService();

const Header = ({
  showBreadcrumb,
  input,
}: {
  showBreadcrumb: boolean;
  input?: Input | null;
}) => {
  const [searchParams] = useSearchParams();
  const [facets, setFacets] = useState<FacetFields>({});

  useEffect(() => {
    solrService.facets<FacetFields>().then((resp) => {
      setFacets(resp ?? {});
    });
  }, []);

  return ["FAF-nt"].includes(process.env.REACT_APP_STYLING_THEME ?? "") ? (
    <NTHeader
      showBreadcrumb={showBreadcrumb}
      input={input}
      searchParams={searchParams}
      facets={facets}
    />
  ) : (
    <BaseHeader
      showBreadcrumb={showBreadcrumb}
      input={input}
      searchParams={searchParams}
      facets={facets}
    />
  );
};

export default Header;
